"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5020,5664],{

/***/ "./src/components/Layout/Navbar/ColorModeToggle.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ ColorModeToggle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/system/node_modules/@chakra-ui/color-mode/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/switch/dist/index.esm.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react-icons/fa/index.esm.js");




const ColorModeToggle = (param)=>{
    let { isInMobileMenu  } = param;
    const { colorMode , toggleColorMode  } = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .useColorMode */ .If)();
    const ColorModeIcon = colorMode === "light" ? react_icons_fa__WEBPACK_IMPORTED_MODULE_3__/* .FaMoon */ .TLr : react_icons_fa__WEBPACK_IMPORTED_MODULE_3__/* .FaSun */ .Mei;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .MenuItem */ .sN, {
            minH: "48px",
            px: isInMobileMenu ? 0 : 3,
            bgColor: !isInMobileMenu ? "subMenuBg" : "transparent",
            sx: {
                "&:hover, &:active, &:focus": {
                    bgColor: !isInMobileMenu ? "subMenuHoverBg" : "transparent"
                }
            },
            onClick: toggleColorMode,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Icon */ .JO, {
                    cursor: "pointer",
                    fontSize: "4xl",
                    color: "linkColor",
                    fontWeight: 600,
                    as: ColorModeIcon,
                    pr: 3
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                    ml: isInMobileMenu ? 2 : "unset",
                    fontSize: "md",
                    fontWeight: "semibold",
                    color: "linkColor",
                    flex: "auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: isInMobileMenu ? {
                                fontSize: 18
                            } : {},
                            children: "Night Mode"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Switch */ .r, {
                            ml: "auto",
                            isChecked: colorMode === "dark",
                            pointerEvents: "none"
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ "./src/components/Layout/Navbar/Logout.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ LogOutBtn; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var _store_slices_user_slice__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/store/slices/user-slice.ts");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/router.js");
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/react-redux/es/index.js");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./node_modules/wagmi/dist/index.js");








const LogOutBtn = (param)=>{
    let { isInMobileMenu  } = param;
    const { isConnected: isUserConnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useAccount */ .mA)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    const { disconnect  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_5__/* .useDisconnect */ .qL)();
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const handleLogOut = ()=>{
        disconnect();
        dispatch((0,_store_slices_user_slice__WEBPACK_IMPORTED_MODULE_1__/* .setStateToDefault */ .GJ)());
        window.localStorage.removeItem("USER_TOKEN");
        router.push(router.asPath);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .MenuItem */ .sN, {
                minH: "48px",
                borderTopWidth: isInMobileMenu ? 0 : "1px",
                px: isInMobileMenu ? 0 : 3,
                bgColor: !isInMobileMenu ? "subMenuBg" : "transparent",
                sx: {
                    "&:hover, &:focus, &:active": {
                        bgColor: "subMenuHoverBg"
                    }
                },
                onClick: isUserConnected ? handleLogOut : undefined,
                cursor: isUserConnected ? "pointer" : "not-allowed",
                display: isUserConnected ? "flex" : "none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Icon */ .JO, {
                        fontSize: "4xl",
                        color: "linkColor",
                        fontWeight: 600,
                        as: react_icons_ri__WEBPACK_IMPORTED_MODULE_9__/* .RiLogoutBoxRFill */ .goJ,
                        pr: 3
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .kC, {
                        ml: isInMobileMenu ? 2 : "unset",
                        fontSize: "md",
                        fontWeight: "semibold",
                        color: "linkColor",
                        flex: "auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: isInMobileMenu ? {
                                fontSize: 18
                            } : {},
                            children: "Log out"
                        })
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ "./src/components/Layout/Navbar/MobileNav.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/@chakra-ui/menu/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/button/dist/index.esm.js");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _data_NavItemData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/data/NavItemData.ts");
/* harmony import */ var _components_Layout_Navbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/components/Layout/Navbar/index.tsx");
/* harmony import */ var _components_Layout_Navbar_NavSearch__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/components/Layout/Navbar/NavSearch/index.tsx");
/* harmony import */ var _utils_WalletUtils_getUserAddressFromCache__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/WalletUtils/getUserAddressFromCache.ts");
/* harmony import */ var _ColorModeToggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/components/Layout/Navbar/ColorModeToggle.tsx");
/* harmony import */ var _Logout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Layout/Navbar/Logout.tsx");
/* harmony import */ var wagmi__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./node_modules/wagmi/dist/index.js");











const MobileNav = (param)=>{
    let { drawerOperations , setHamburger  } = param;
    const userAddress = (0,_utils_WalletUtils_getUserAddressFromCache__WEBPACK_IMPORTED_MODULE_7__/* .getUserAddressFromCache */ .X)();
    const [showSubNav, setShowSubNav] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [currentMenu, setCurrentMenu] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const { isConnected  } = (0,wagmi__WEBPACK_IMPORTED_MODULE_8__/* .useAccount */ .mA)();
    const iconSize = 20;
    const handleClick = (currentNav)=>{
        if (currentNav === null || currentNav === void 0 ? void 0 : currentNav.subItem) {
            setCurrentMenu(currentNav);
            setShowSubNav(true);
        } else {
            setHamburger(false);
        }
    };
    const handleWalletButtonClick = ()=>{
        setHamburger(false);
        drawerOperations.onToggle();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .VStack */ .gC, {
        justify: "space-between",
        align: "stretch",
        backgroundColor: "subMenuBg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                borderTopWidth: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Navbar_NavSearch__WEBPACK_IMPORTED_MODULE_4__["default"], {
                        inputGroupProps: {
                            display: {
                                base: "inherit",
                                md: "none"
                            }
                        },
                        inputProps: {
                            my: 2,
                            width: "90%",
                            mx: "5%"
                        },
                        listProps: {
                            w: "full",
                            rounded: "none",
                            mt: 0
                        },
                        setHamburger: setHamburger
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Divider */ .iz, {}),
                    !showSubNav ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                        px: {
                            base: 4,
                            md: 8
                        },
                        h: {
                            base: !userAddress ? "max(calc(100vh - 300px), 350px)" : "max(calc(100vh - 240px), 350px)",
                            md: "calc(100vh - 180px)"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                            display: {
                                base: "flex",
                                xl: "none"
                            },
                            flexDirection: "column",
                            justifyContent: "space-between",
                            mt: 5,
                            h: !userAddress ? "min(100%, 400px)" : "min(100%, 500px)",
                            bg: "subMenuBg",
                            px: 6,
                            pb: 6,
                            children: [
                                (0,_data_NavItemData__WEBPACK_IMPORTED_MODULE_2__/* .MOBILE_NAV_ITEMS */ .a7)({
                                    address: userAddress || undefined
                                }).filter((i)=>i.label !== "Account" || userAddress).map((navItem)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Navbar__WEBPACK_IMPORTED_MODULE_3__/* .MobileNavItem */ .kX, {
                                        handleClick: (item)=>handleClick(item),
                                        navItem: navItem
                                    }, navItem.label)),
                                userAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                                    display: {
                                        sm: "block",
                                        md: "none",
                                        lg: "none"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Navbar__WEBPACK_IMPORTED_MODULE_3__/* .MobileNavItem */ .kX, {
                                        handleClick: handleWalletButtonClick,
                                        navItem: _data_NavItemData__WEBPACK_IMPORTED_MODULE_2__/* .mobileWalletDetails */ .Kw
                                    }, _data_NavItemData__WEBPACK_IMPORTED_MODULE_2__/* .mobileWalletDetails.label */ .Kw.label)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Menu */ .v2, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                                        gap: "4",
                                        direction: "column",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ColorModeToggle__WEBPACK_IMPORTED_MODULE_5__/* .ColorModeToggle */ .c, {
                                                isInMobileMenu: true
                                            }),
                                            isConnected && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Logout__WEBPACK_IMPORTED_MODULE_6__/* .LogOutBtn */ .W, {
                                                isInMobileMenu: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                        h: "calc(100vh - 220px)",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout_Navbar__WEBPACK_IMPORTED_MODULE_3__/* .MobileSubNav */ .N1, {
                            setHamburger: setHamburger,
                            setShowSubNav: setShowSubNav,
                            activeMenu: currentMenu,
                            setActiveMenu: setCurrentMenu
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                display: {
                    lg: "block",
                    xl: "none"
                },
                children: [
                    !showSubNav && !userAddress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .xu, {
                        mb: 3,
                        px: 6,
                        display: {
                            sm: "flex",
                            md: "none"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Button */ .zx, {
                            onClick: handleWalletButtonClick,
                            size: "lg",
                            w: "full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .xv, {
                                children: "Connect wallet"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Center */ .M5, {
                        bg: "subMenuBg",
                        h: "80px",
                        borderTopWidth: "thin",
                        borderTopColor: "borderColor",
                        color: "homeDescriptionColor",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Flex */ .kC, {
                            gap: 8,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiInstagramFill */ .Nrw, {
                                    size: iconSize
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiLinkedinFill */ .ExP, {
                                    size: iconSize
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiFacebookFill */ .NqZ, {
                                    size: iconSize
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiTelegramFill */ .jll, {
                                    size: iconSize
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_12__/* .RiTwitterFill */ .x2F, {
                                    size: iconSize
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MobileNav);


/***/ })

}]);